module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 50 50\"><title>smiley-face</title><path class=\"icon-fill\" d=\"M25,0A25,25,0,1,0,50,25,25,25,0,0,0,25,0Zm6.36,15.2a2.94,2.94,0,1,1-2.93,2.94h0A2.94,2.94,0,0,1,31.36,15.2Zm-12.75,0a3,3,0,1,1-.05,0h.05ZM37.5,33.42a12.7,12.7,0,0,1-25,0l-.1-.58H37.6Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/smiley-face.svg
// module id = 563
// module chunks = 1